<template>
  <TabsRoot :default-value="defaultValue" v-model="activeTab" class="w-full">
    <TabsList class="border-b border-theme-placeholder-bg">
      <div class="flex gap-8">
        <TabsTrigger
          v-for="tab in tabs"
          :key="tab.key"
          :value="tab.key"
          class="relative cursor-pointer pb-2 text-base font-medium text-theme-1 outline-none before:absolute before:bottom-0 before:left-0 before:h-0.5 before:w-full before:origin-left before:bg-theme-1 before:transition-transform before:duration-200 before:ease-out before:content-[''] data-[state=inactive]:before:scale-x-0"
        >
          {{ tab.label }}
        </TabsTrigger>
      </div>
    </TabsList>

    <div class="grid">
      <div
        v-for="tab in tabs"
        :key="tab.key"
        class="col-start-1 row-start-1"
        :class="{
          invisible: tab.key !== activeTab,
          visible: tab.key === activeTab,
        }"
      >
        <slot :name="tab.key" />
      </div>
    </div>
  </TabsRoot>
</template>

<script setup lang="ts">
import { TabsContent, TabsList, TabsRoot, TabsTrigger } from "radix-vue";

export interface Tab {
  label: string;
  key: string;
}

defineProps<{
  modelValue?: string;
  defaultValue?: string;
  tabs: Tab[];
}>();

const activeTab = defineModel<string>();

defineEmits<{
  "update:modelValue": [value: string];
}>();
</script>
